import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../utils/networking";

const TagManagement = () => {
  const [tags, setTags] = useState([]);
  const [ptags, setPtags] = useState([]);
  useEffect(() => {
    //Get tags from backend
    axiosInstance.get(`/tags`).then((res) => {
      setTags(res.data.tags);
    });

    axiosInstance.get(`/tags/provider`).then((res) => {
      setPtags(res.data.tags);
    });
  }, []);

  //   const handleClick = () => {
  //     console.info("You clicked the Chip.");
  //   };

  const handleDelete = (tag: string) => {
    console.info("Deleted tag: " + tag);
    axiosInstance.delete(`/tags/${tag}`).then(() => {
      window.location.reload();
    });
  };

  const handleProviderDelete = (tag: string) => {
    console.info("Deleted tag: " + tag);
    axiosInstance.delete(`/tags/provider/${tag}`).then(() => {
      window.location.reload();
    });
  };

  return (
    <Stack spacing={10}>
      <Box>
        <Typography variant="h4">Resource Tags</Typography>
        <Paper>
          {tags.map((tag, index) => {
            return (
              <Chip
                sx={{ margin: "5px", fontSize: "1.2rem" }}
                key={index}
                label={tag}
                // onClick={handleClick}
                onDelete={() => {
                  handleDelete(tag);
                }}
              />
            );
          })}
        </Paper>
      </Box>
      <Box>
        <Typography variant="h4">Provider Tags</Typography>
        <Paper>
          {ptags.map((tag) => {
            return (
              <Chip
                sx={{ margin: "5px", fontSize: "1.2rem" }}
                key={tag}
                label={tag}
                // onClick={handleClick}
                onDelete={() => {
                  handleProviderDelete(tag);
                }}
              />
            );
          })}
        </Paper>
      </Box>
    </Stack>
  );
};

export default TagManagement;
